export const ART_SIZE = {
  width: { mobile: 300, desktop: 500 },
  height: { mobile: 400, desktop: 500 },
};

export const CONTAINER_SIZE = {
  xs: 300,
  sm: 500,
};
